// src/components/UI/Popup.js
import React from 'react';

const Popup = ({ 
  onPrimaryAction,     // The main action (e.g. Reply or View answer)
  primaryLabel,        // Label for the primary action button
  onToggleDisplay,     // Toggle display on profile (if applicable)
  displayToggleLabel,  // Label for the toggle button (“Hide from profile” or “Show on profile”)
  onDelete,            // Delete action (with confirmation)
  onClose,             // Callback to close the popup
  confirm,             // If true, show confirmation UI for delete
  onOpenConfirm        // Callback to open the confirmation state
}) => {
  return (
    <div className="popup" onClick={(e) => e.stopPropagation()}>
      <ul>
        {/* Primary action comes first */}
        {onPrimaryAction && (
          <li>
            <button
              className="popup-action"
              onClick={(e) => {
                e.stopPropagation();
                console.log(`${primaryLabel} clicked`);
                onPrimaryAction();
                onClose();
              }}
            >
              {primaryLabel}
            </button>
          </li>
        )}

        {/* Toggle display option (if provided) comes next */}
        {onToggleDisplay && (
          <li>
            <button
              className="popup-action"
              onClick={(e) => {
                e.stopPropagation();
                console.log(`${displayToggleLabel} clicked`);
                onToggleDisplay();
                onClose();
              }}
            >
              {displayToggleLabel}
            </button>
          </li>
        )}

        {/* Delete option comes last */}
        {onDelete && (
          <li>
            {confirm ? (
              <>
                <span>Are you sure?</span>
                <div>
                  <button
                    className="popup-action"
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("Confirmed delete");
                      onDelete();
                      onClose();
                    }}
                  >
                    Yes, delete
                  </button>
                  <button
                    className="popup-action"
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("Delete canceled");
                      onClose();
                    }}
                  >
                    No
                  </button>
                </div>
              </>
            ) : (
              <button
                className="popup-action"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log("Delete option clicked - opening confirmation");
                  onOpenConfirm && onOpenConfirm();
                  // Do not close the popup here so that confirmation remains visible.
                }}
              >
                Delete
              </button>
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default Popup;
